(function histallay_video($, Drupal) {
    Drupal.behaviors.histallay_header = {
      attach(context, settings) {
        var path = $(location).attr('href');
        path = path.split('/')
        if (path[3] == 'medical-professionals') {
          if ($('.navigation__item').hasClass('open-modal-medi')) {
            $('.open-modal-medi').addClass('navigation__item--active-trail');
          }
        }
      },
    };
  })(jQuery, Drupal);
  